import { app } from '../../app';

app.run(init);

/** @ngInject */
function init($transitions) {
    $transitions.onSuccess({}, () => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    /* todo: delete after all modals are converted to $uibModal */
    $(() => $('body').on('hide.bs.modal', () => $('.modal-body').scrollTop(0)));
}



// WEBPACK FOOTER //
// ./src/portal/init/ui-router/scroll-to-top.js